module.exports = __webpack_public_path__ + "img/SEBRAE-colorida.6a7c49a5.png";